/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Typography } from "@mui/material";

/**
 * This belongs in a more global space so that all form labels are handled same way.
 *
 * @param text
 * @returns {JSX.Element}
 * @constructor
 */
const FormLabel = (props) => {
    
    const { text } = props;
    
    return (
        <Typography variant='overline' color={"text.secondary"}>
            {text}:
        </Typography>
    );
};

FormLabel.displayName = "FormLabel";
export { FormLabel };
